export enum AddProductConfigurationViewMode {
  GENERAL = 'GENERAL',
  OPTIONAL_SETTINGS = 'OPTIONAL_SETTINGS',
  VERSION_HISTORY = 'VERSION_HISTORY'
}
